
angular.module('app.controllers').controller 'ContactModalCtrl', [
  '$scope', '$rootScope', 'APIForm', 'UI', 'APIInquiries', 'APIFavorites', '$cookies'
].append (self, root, APIForm, UI, APIInquiries, APIFavorites, $cookies) ->

  self.data = null
  self.formProccess = false
  self.formSuccess = false
  
  self.saveForm = (form) ->
    self.cForm = form

  self.contactModalEl = document.getElementById('contactModal')

  if self.contactModalEl
    self.contactModal = bootstrap.Modal.getOrCreateInstance(self.contactModalEl) 

    self.contactModalEl.addEventListener('hidden.bs.modal', (event) ->
      self.data = null
      self.inquiry = null
      self.formProccess = false
      self.formSuccess = false
      self.cForm.$setPristine()
      self.cForm.$setUntouched()
      self.$applyAsync()
    )

    self.contactModalEl.addEventListener('show.bs.modal', (event) ->      
      self.$applyAsync()
    )

  self.$on 'onContactModalOpen', (event, email = '', name = '', favs = false) ->
    self.fake =
      themes: []

    if favs 
      APIFavorites.query {shortcode: root.user?.shortcode || root.tuser || 'test', tuser: root.tuser || null, _themes: true, lang: root.lang || 'es'}, (data) ->
        self.themes = data
        self.data = 
          favs: favs
          favs_themes: ''
        self.contactModal.show()

    else
      self.data = 
        to_email: email
        to_name: name
        email: root.session?.user?.email || 'noreply@mailer.dmas.at'
        name: root.session?.user?.name || 'Playground User'
        message: ''
        favs: favs
        favs_themes: ''

      self.contactModal.show()

  self.setFavsThemes = () ->
    self.formProccess = true
    self.formSuccess  = false
    self.data.favs_themes = self.fake.themes.join(", ")
    tempEntry_id = Date.now()
    self.toggleFavs('cr', {entry_id: tempEntry_id, exhibitor_id: 1, favs_themes: self.data.favs_themes})
  
  root.$on 'finishContactRequest', (event) ->
    self.formProccess = false
    self.formSuccess  = true

  self.sendContact = () ->
    self.formProccess = true

    description = ["Email: #{self.data.to_email}", "Name: #{self.data.to_name}", "Message: #{self.data.message}"]
    description.unshift("Theme: #{self.data.favs_themes}") if self.data.favs

    self.inquiry = new APIInquiries
      title: "Kontakt"
      methods: ['notice']
      shortcode: root.user?.shortcode
      exhibitor_id: null
      description: description.join "\n"

    (new APIForm self.data).$save {lang: root.lang || 'es'}, (data) ->

      #now = new Date()
      #$cookies.put('s_e365_theme', 1, {expires: new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)}) if self.data.favs

      if root.user?.auth_ticket
        self.inquiry.$save {_private: true, auth_ticket: root.user?.auth_ticket}, (data) ->
          self.customStat(null, 'send_message', "Contact to #{self.data.to_email}: #{self.data.message}")
        , (response) ->
          UI.notify false, response.data.error
      else
        self.customStat(null, 'send_message', "Contact to #{self.data.to_email}: #{self.data.message}")

      self.formSuccess = true if data.success

      self.cForm.$setPristine()
      self.cForm.$setUntouched()

    , (response) ->
      self.formProccess = false
      UI.notify false, response.data.error